import { Trash } from "@phosphor-icons/react";

const fmtWhen = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const days = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (days === 0) return d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
  if (days === 1) return "yesterday";
  if (days < 7) return `${days}d ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};

export default function CopilotSidebar({ sessions, activeSessionId, onLoad, onDelete }) {
  return (
    <div
      className="w-[150px] flex-shrink-0 border-r border-zinc-200 bg-zinc-50 overflow-y-auto"
      data-testid="copilot-sessions-sidebar"
    >
      <div className="px-2 py-2 font-mono text-[9px] tracking-[0.2em] text-zinc-400 uppercase">
        Recent
      </div>
      {sessions.length === 0 ? (
        <div className="px-2 py-1 text-[11px] text-zinc-400">No chats yet</div>
      ) : (
        sessions.map((s) => (
          <div
            key={s.session_id}
            className={`group flex items-stretch border-b border-zinc-100 hover:bg-white transition-colors ${
              activeSessionId === s.session_id ? "bg-white border-l-2 border-l-[#FF3E00]" : ""
            }`}
            data-testid={`copilot-session-${s.session_id}`}
          >
            <button
              onClick={() => onLoad(s.session_id)}
              className="flex-1 text-left px-2 py-2"
            >
              <div className="text-[11px] text-zinc-950 line-clamp-2 leading-snug">{s.title}</div>
              <div className="mt-1 font-mono text-[9px] text-zinc-400">{fmtWhen(s.updated_at)}</div>
            </button>
            <button
              onClick={(e) => { e.stopPropagation(); onDelete(s.session_id); }}
              className="opacity-0 group-hover:opacity-100 px-2 text-zinc-400 hover:text-[#D0021B] transition-opacity"
              title="Delete chat"
              data-testid={`copilot-delete-${s.session_id}`}
            >
              <Trash size={11} />
            </button>
          </div>
        ))
      )}
    </div>
  );
}
